import React from 'react';
import { WishlistButton, WishlistButtonState } from '../../WishlistButton/WishlistButton';
import { styles } from './ProductCardHeader.css';
import { PromoTagType } from '../types';
import { ProductCardVariant } from '../ProductCard';
import BannerTag from '@jbhi-fi/lanyard-ui/components/BannerTag';
import PromoTag from '@jbhi-fi/lanyard-ui/components/PromoTag';
import { ProductCardDetails } from '../ProductCardDetails/ProductCardDetails';
import { ProductDetail } from '../types';

export type ProductCardHeaderProps = {
  bannerLabel?: string;
  promoTags?: Array<PromoTagType>;
  wishlistState?: WishlistButtonState;
  shouldHideWishlist?: boolean;
  variant: ProductCardVariant;
  wishlistOnClick?: (e?: any) => void;
  shouldHideBannerTag?: boolean;
  shouldHidePromoTag?: boolean;
  details?: ProductDetail;
  productGroupId?: number;
  isProductCardDetailBadgesEnabled?: boolean;
};

export const ProductCardHeader = ({
  bannerLabel,
  promoTags,
  wishlistState,
  shouldHideWishlist,
  variant,
  wishlistOnClick,
  shouldHideBannerTag,
  shouldHidePromoTag,
  details,
  productGroupId,
  isProductCardDetailBadgesEnabled,
}: ProductCardHeaderProps) => {
  const hasWishlistButton = !!wishlistOnClick;
  const shouldDisplayWishlist = !shouldHideWishlist && wishlistState && hasWishlistButton;
  const shouldDisplayPromoTags = !shouldHidePromoTag && promoTags?.length;
  const shouldDisplayBannerTag = !shouldHideBannerTag && bannerLabel;
  const shouldDisplayDetailBadges = Boolean(isProductCardDetailBadgesEnabled && details);

  const handleWishlistClick = (e: any) => {
    wishlistOnClick?.(e);
  };

  return (
    <div className={styles.container({ variantType: variant })}>
      {shouldDisplayBannerTag ? (
        <div className={styles.bannerTagContainer}>
          <BannerTag
            testId="product-card-banner-tag"
            size={variant === 'default' ? 'lg' : variant === 'small' ? 'sm' : 'responsive'}
            label={bannerLabel}
          />
        </div>
      ) : null}
      {shouldDisplayPromoTags
        ? promoTags.map((tag, i) => {
            return (
              <div key={`${tag.label}-${i}`} className={styles.promoTag({ variantType: variant })}>
                <PromoTag
                  testId={`product-card-promo-tag-${i}`}
                  size={variant === 'default' ? 'sm' : 'smResponsive'}
                  key={`${tag.label}-${i}`}
                  label={tag.label}
                />
              </div>
            );
          })
        : null}

      {shouldDisplayDetailBadges ? (
        <ProductCardDetails
          details={details ?? null}
          hasSiblings={Boolean(shouldDisplayBannerTag || shouldDisplayPromoTags)}
          productGroupId={productGroupId}
        />
      ) : null}

      {shouldDisplayWishlist ? (
        <div className={styles.wishlistButtonContainer({ variantType: variant })}>
          <WishlistButton
            testId="product-card-wishlist-button"
            state={wishlistState}
            type="iconOnly"
            onClick={handleWishlistClick}
            isLoading={wishlistState === 'loading'}
            iconSize={'sm'}
          />
        </div>
      ) : null}
    </div>
  );
};
